import { Validators } from '@angular/forms';
import { CrudViewFormItemType, FormLayout } from '@rappider/rappider-components/utils';
export const FILE_LIST_EDIT_FORM_CONFIG = {
  items: [
    {
      showRequiredSign: true,
      fieldName: 'categoryId',
      title: 'Category',
      type: CrudViewFormItemType.Select,
      selectOptions: [
      ],
      validators: [
        {
          type: Validators.required,
          errorKey: 'required',
          errorMessage: 'ERRORS.PATTERN_MESSAGES.REQUIRED_FIELD_MESSAGE'
        }
      ]
    },
    {
      showRequiredSign: true,
      visible: true,
      fieldName: 'ingestDataTo',
      title: 'Ingest data to:',
      type: CrudViewFormItemType.Radio,
      direction: 'vertical',
      options: [
        {
          key: 'Ingest to a new data table',
          value: 'ingestToAnewDataTable'
        },
        {
          key: 'Ingest to an existing data table',
          value: 'IngestToAnExistingDataTable'
        },
        {
          key: 'Ingest to the default data table of the data source',
          value: 'IngestToTheDefaultDataTableOfTheDataSource'
        }
      ],
      validators: [
        {
          type: Validators.required,
          errorKey: 'required',
          errorMessage: 'ERRORS.PATTERN_MESSAGES.REQUIRED_FIELD_MESSAGE'
        }
      ],
      default: 'IngestToTheDefaultDataTableOfTheDataSource',
    },
    {
      visible: false,
      fieldName: 'selectProjectModel',
      title: 'Select Project Model',
      type: CrudViewFormItemType.Select,
      selectOptions: [
      ],
      default: 'IngestToTheDefaultDataTableOfTheDataSource',
    },
    {
      showRequiredSign: true,
      type: CrudViewFormItemType.CheckBox,
      default: true,
      title: 'AI File Processing Approval',
      text: {
        text: 'By approving, you allow your files to be reviewed and processed by AI. This ensures they can be utilized in advanced search and analysis features.'
      },
      fieldName: 'isApproved'
    },
  ],
  itemSettings: {
    inputComponentSize: {
      xs: 24
    },
    labelComponentSize: {
      xs: 24
    },
  },
  submitButton: {
    visible: false
  },
  formLayout: FormLayout.Vertical
};

